import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Button, Grid } from '@mui/material';
import { ReactNode } from 'react';
import ResetButton from './IconButtons/ResetButton';

interface NoResultsProps {
  message: string | ReactNode;
  icon?: string;
  resetText?: string;
  onClear?: () => void;
}

const NoResults = ({ message = 'No results found.', icon, resetText, onClear }: NoResultsProps) => {
  return (
    <Grid container flexDirection="column" alignItems="center" justifyContent="center" sx={{ height: '70%', maxHeight: 500 }}>
      <IconWrapper>{icon || <PolarisIcon icon="search_results" height={50} />}</IconWrapper>
      <NoResultsWrapper item container alignItems="center" justifyContent="center">
        {message}
      </NoResultsWrapper>
      {onClear && (
        <Grid item sx={{ mt: 2.5 }}>
          <ResetButton label={resetText ?? 'Reset Search'} onClick={onClear} />
        </Grid>
      )}
    </Grid>
  );
};

export default NoResults;

const IconWrapper = styled.div`
  text-align: center;
  opacity: 0.25;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const NoResultsWrapper = styled(Grid)`
  text-align: center;
  font-size: 1.2rem;
  font-weight: ${({ theme }) => theme.typography.fontWeightLight};
`;
